import React, { useState, useRef } from "react";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./ModalEditarAluno.css";

const ModalEditarAluno = ({ aluno, onClose, onAtualizar }) => {
  const [formData, setFormData] = useState({ ...aluno });
  const [erros, setErros] = useState({});
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErros(prev => ({ ...prev, [name]: "" }));
  };

  const validarCampos = () => {
    const novosErros = {};

    if (!formData.nome_completo) novosErros.nome_completo = "Nome é obrigatório";
    if (!formData.telefone_responsavel) novosErros.telefone_responsavel = "Telefone do responsável é obrigatório";

    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      novosErros.email = "Email inválido";
    }

    // Validação condicional do BI
    if (formData.tipo_documento === "BI" && formData.numero_documento) {
      const biRegex = /^[0-9]{12}[A-Z]$/;
      if (!biRegex.test(formData.numero_documento)) {
        novosErros.numero_documento = "Número de BI inválido (12 dígitos + 1 letra maiúscula)";
      }
    }

    return novosErros;
  };

  const handleSalvar = async () => {
    const errosValidacao = validarCampos();

    if (Object.keys(errosValidacao).length > 0) {
      setErros(errosValidacao);
      const primeiroErro = Object.keys(errosValidacao)[0];
      toast.warn("⚠️ Corrija os erros antes de salvar.");
      inputRefs.current[primeiroErro]?.focus();
      return;
    }

    setLoading(true);
    try {
      const resposta = await fetch(`http://localhost:5000/api/alunos/${aluno.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (resposta.ok) {
        const dadosAtualizados = await resposta.json();
        toast.success("✅ Aluno atualizado com sucesso!");
        if (onAtualizar) onAtualizar(dadosAtualizados.aluno);
        setTimeout(() => onClose(), 1500);
      } else {
        toast.error("❌ Erro ao atualizar aluno.");
        console.error("Resposta do servidor:", resposta.status);
      }
    } catch (erro) {
      toast.error("❌ Erro ao conectar com o servidor.");
      console.error("Erro na requisição:", erro);
    } finally {
      setLoading(false);
    }
  };

  const campos = [
    {
      categoria: "Informações Básicas", itens: [
        { label: "Nome Completo", name: "nome_completo" },
        { label: "Gênero", name: "genero", type: "select", options: ["Masculino", "Feminino", "Outro"] },
        { label: "Data de Nascimento", name: "data_nascimento", type: "date" },
        { label: "Classe", name: "classe", type: "select", options: ["1ª", "2ª", "3ª", "4ª", "5ª", "6ª", "7ª", "8ª", "9ª", "10ª", "11ª", "12ª"] },
        { label: "Tipo de Documento", name: "tipo_documento", type: "select", options: ["BI", "Cédula"] },
        { label: "Número do Documento", name: "numero_documento" },
        { label: "Nacionalidade", name: "nacionalidade" },
        { label: "Naturalidade", name: "naturalidade" },
      ]
    },
    {
      categoria: "Contato e Saúde", itens: [
        { label: "Email", name: "email", type: "email" },
        { label: "Telefone do Responsável", name: "telefone_responsavel" },
        { label: "Histórico Médico", name: "historico_medico" },
        { label: "Deficiência", name: "deficiencia" },
        { label: "Doença Crônica", name: "doenca_cronica" },
        { label: "Outras Condições", name: "outras_condicoes" },
      ]
    },
    {
      categoria: "Informações Familiares", itens: [
        { label: "Nome do Pai", name: "nome_pai" },
        { label: "Telefone do Pai", name: "telefone_pai" },
        { label: "Nome da Mãe", name: "nome_mae" },
        { label: "Telefone da Mãe", name: "telefone_mae" },
      ]
    },
    {
      categoria: "Financeiro", itens: [
        { label: "Valor da Matrícula (MZN)", name: "valor_matricula", type: "number" },
        { label: "Base Mensal (MZN)", name: "base_mensal", type: "number" },
        { label: "Turma", name: "turma" },
        { label: "Data da Matrícula", name: "data_matricula", type: "date" },
      ]
    }
  ];

  return (
    <div className="modal">
      <div className="modal-editar-content">
        <h2>Editar Informações do Pré-registo</h2>

        {campos.map((grupo) => (
          <div key={grupo.categoria} className="grupo-categoria">
            <h4>{grupo.categoria}</h4>
            <div className="grupo-campos">
              {grupo.itens.map((field) => (
                <div key={field.name} className="campo-form">
                  <label htmlFor={field.name}>{field.label}</label>
                  {field.type === "select" ? (
                    <select
                      id={field.name}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleChange}
                      ref={el => inputRefs.current[field.name] = el}
                    >
                      <option value="">Selecione</option>
                      {field.options.map(opt => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  ) : (
                    <input
                      id={field.name}
                      type={field.type || "text"}
                      name={field.name}
                      value={field.type === "date" && formData[field.name]
                        ? formData[field.name].slice(0, 10)
                        : formData[field.name] || ""}
                      onChange={handleChange}
                      ref={el => inputRefs.current[field.name] = el}
                    />
                  )}
                  {erros[field.name] && <span className="erro-campo">{erros[field.name]}</span>}
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="botoes-inferiores">
          <button
            className="btn-modal-salvar"
            onClick={handleSalvar}
            disabled={loading}
          >
            {loading ? "Salvando..." : "Salvar"}
          </button>
          <button className="btn-modal-cancelar" onClick={onClose}>Cancelar</button>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default ModalEditarAluno;
